import { Card, CardContent } from '@design-system';
import { consumerQuoteCarrier, type ConsumerQuote } from '@shared/consumerPlan';
import { getCarrierLogoSrc } from '@/util/carrierLogo';
import { premiumText } from '../lib/format';

export function SelectedCoverageSummary({ quote }: { quote: ConsumerQuote }) {
  const carrier = consumerQuoteCarrier(quote);

  return (
    <Card className="py-3 sm:py-4">
      <CardContent className="flex items-center gap-2 px-3 sm:gap-3 sm:px-4">
        <img src={getCarrierLogoSrc(carrier)} alt="" className="h-6 max-w-20 object-contain sm:h-8 sm:max-w-24" />
        <div className="flex flex-col">
          <strong className="text-sm font-semibold text-gray-950 sm:text-base">
            {carrier} · {quote.productName}
          </strong>
          <span className="text-muted-foreground text-xs sm:text-sm">{premiumText(quote)}</span>
        </div>
      </CardContent>
    </Card>
  );
}
